import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getRestrictionData = createAsyncThunk(
  "restriction data",
  async ({ folderId, linkEntryId, fileEntryId }) => {
    let response;
    try {
      if (folderId) {
        response = await axios(`/folder/settings/${folderId}/restriction/form`);
      } else {
        const formData = new FormData();
        linkEntryId && formData.append("linkType", linkEntryId);
        fileEntryId && formData.append("fileType", fileEntryId);
        response = await axios.post(
          `/entry/settings/restriction/form`,
          formData
        );
      }
      return response.data;
    } catch (err) {}
  }
);
